import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/index'

Vue.use(Router)
console.log(11111,window.g.BASE_ROUTER)
export default new Router({
  mode: 'history',
  base: window.g.BASE_ROUTER,
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/index',
      children: [{
        path: 'index',
        name: 'Index',
        component: () =>
          import('@/views/index')
      }]
    },
    {
      path: '/purchase',
      component: Layout,
      children: [
        {
          path: '/purchase',
          name: 'Purchase',
          component: () => import('@/views/purchase'),
        }
      ]
    },
    {
      path: '/order',
      component: Layout,
      children: [
        {
          path: '/order',
          name: 'Order',
          component: () => import('@/views/order'),
        }
      ]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js